// New file: complete-your-garden-slider.js
$(document).ready(function(){
    // Каждый слайдер инициализируется отдельно: у "Buy Set - Save More" в колонке
    // товара (--in-column) помещается 2 карточки, у широкой секции — 6.
    // Стрелки привязаны к своей секции, а не ко всем слайдерам на странице.
    $('.complete-your-garden-section').each(function(){
        var $section = $(this);
        var inColumn = $section.hasClass('complete-your-garden-section--in-column');
        var slider = $section.find('.complete-your-garden-section__container').slick({
            infinite: false,
            slidesToShow: inColumn ? 2 : 6,
            slidesToScroll: 1,
            variableWidth: false,
            arrows: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 1024, // Below desktop: unslick (mobile uses native scroll / hidden)
                    settings: "unslick"
                }
            ]
        });

        $section.find('.complete-your-garden-section__arrow--prev').click(function(){
            slider.slick('slickPrev');
        });

        $section.find('.complete-your-garden-section__arrow--next').click(function(){
            slider.slick('slickNext');
        });
    });
});
